import React, { useEffect } from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import { Link } from 'react-router-dom';
import GridItem from '../../Grid/GridItem.js';
import GridContainer from '../../Grid/GridContainer.js';
import Button from '../../CustomButtons/Button.js';
import { connect } from 'react-redux';
import Card from '../../Card/Card.js';
import CardHeader from '../../Card/CardHeader.js';
import { getUserDetails as getUserList } from '../../../store/actions/user/User';
import CardBody from '../../Card/CardBody.js';
import CardFooter from '../../Card/CardFooter.js';

const styles = {
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);
var update = false;
function UserDetails(props) {
  useEffect(() => {
    props.getUserList();
  }, [update]);

  const classes = useStyles();
  return (
    <Card>
      <Card>
        <CardHeader style={{ background: '#34BA92' }}>
          <h4 className={classes.cardTitleWhite}>My Profile Details</h4>
          <p className={classes.cardCategoryWhite}>Personnal Informations</p>
        </CardHeader>
        {props.userDetails !== undefined && props.userDetails.length !== 0 ? (
          <CardBody>
            <p
              style={{
                textAlign: 'left',
                paddingLeft: '9px',
                fontSize: '15px',
                fontWeight: 'bold',
                paddingRight: '9px',
                paddingTop: '9px',
                color: '#00000090',
                borderRadius: '6px',
                paddingBottom: '9px',
                width: '152px',
                backgroundColor: '#34A9A230'
              }}
            >
              Basic informations
            </p>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <p style={{ textAlign: 'left', fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>Firstname:</span>{' '}
                  {props.userDetails.firstName}
                </p>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>Lastname:</span>{' '}
                  {props.userDetails.lastName}
                </p>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>Username:</span>{' '}
                  {props.userDetails.userName}
                </p>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <div className={classes.typo}>
                  <p style={{ textAlign: 'left', fontWeight: 400 }}>
                    <span style={{ fontWeight: 600 }}>Email:</span>{' '}
                    {props.userDetails.emailId}
                  </p>
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <div className={classes.typo}>
                  <p style={{ fontWeight: 400 }}>
                    <span style={{ fontWeight: 600 }}>Date of birthday:</span>{' '}
                    {props.userDetails.DOB}
                  </p>
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}></GridItem>
            </GridContainer>
            <br />
            <p
              style={{
                textAlign: 'left',
                paddingLeft: '9px',
                fontSize: '15px',
                fontWeight: 'bold',
                paddingRight: '9px',
                paddingTop: '9px',
                color: '#00000090',
                borderRadius: '6px',
                paddingBottom: '9px',
                width: '172px',
                backgroundColor: '#34A9A230'
              }}
            >
              Adress informations
            </p>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <p style={{ textAlign: 'left', fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>Country:</span>{' '}
                  {props.userDetails?.address?.country}
                </p>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>State:</span>{' '}
                  {props.userDetails?.address?.state}
                </p>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>City:</span>{' '}
                  {props.userDetails?.address?.city}
                </p>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <p style={{ textAlign: 'left', fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>Pincode:</span>{' '}
                  {props.userDetails?.address?.pincode}
                </p>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>
                    Adress Building Number:
                  </span>{' '}
                  {props.userDetails?.address?.building_number}
                </p>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>Adress street:</span>{' '}
                  {props.userDetails?.address?.street}
                </p>
              </GridItem>
            </GridContainer>
          </CardBody>
        ) : (
          <>
            <img
              src="https://inolemit.sirv.com/utils/35%20(1).gif"
              style={{
                width: '100px',
                height: '100px',
                marginRight: 0,
                itemsAlign: 'center'
              }}
              alt=""
            />{' '}
            <br />{' '}
          </>
        )}
        <CardFooter>
          <Link to="/user/update">
            <Button style={{ background: '#34BA92' }}>Update Profile</Button>{' '}
          </Link>
        </CardFooter>
      </Card>
    </Card>
  );
}

const mapStateWithProps = (state) => ({
  userDetails: state.user.userDetails
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getUserList: () => dispatch(getUserList())
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(UserDetails);
